import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';

const quoteSizes = {
  full: css`
    grid-column: 2/-2;
  `,
  half: css`
    grid-column: 2/8;
  `,
  threeFourth: css`
    grid-column: 2/11;
  `,
  quarter: css`
    grid-column: 2/7;
  `,
};

export const ArticleQuoteWrapper = styled.div<{ type: string }>`
  ${({ type }) => (quoteSizes[type] ? quoteSizes[type] : 'grid-column: 4/-4;')}

  margin-bottom: 64px;

  ${mediaDesktop(css`
    margin-bottom: 96px;
  `)}
`;

export const Quote = styled.div<{ variant: string }>`
  ${({ theme: { locale } }) => setTypography('heading2', locale)}

  padding-bottom: 32px;
  quotes: 'a' 'a';

  ${({ variant }) =>
    variant === 'large' ? setTypography('heading2') : setTypography('heading3')}
`;

export const Author = styled.div`
  ${({ theme: { locale } }) => setTypography('smallBody', locale)}

  display: flex;
  flex-direction: column;
`;
